import axios from 'axios';
import { handleAuthError } from '../funciones/authHelper';
import { getCachedData, invalidateCacheByPrefix, CACHE_KEYS } from '../funciones/apiCache';

const API_URL = process.env.REACT_APP_API_URL;

const FESTIVOS_CACHE_TTL = 5 * 60 * 1000;

export const fetchFestivos = async (params = {}, forceRefresh = false) => {
    const cacheKey = `${CACHE_KEYS.FESTIVOS}_${params.anio || 'all'}`;

    const fetchFn = async () => {
        const response = await axios.get(`${API_URL}/api/festivos`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            },
            params
        });
        return response.data;
    };

    try {
        if (forceRefresh) {
            invalidateCacheByPrefix(CACHE_KEYS.FESTIVOS);
        }
        return await getCachedData(cacheKey, fetchFn, FESTIVOS_CACHE_TTL);
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchFestivosCombinados = async (anio, provincia = null, municipio = null, esColaborador = false) => {
    const cacheKey = `${CACHE_KEYS.FESTIVOS}_combinados_${anio}_${provincia || ''}_${municipio || ''}_${esColaborador ? 'colab' : 'int'}`;

    const fetchFn = async () => {
        const params = { anio };
        if (provincia) params.provincia = provincia;
        if (municipio) params.municipio = municipio;
        if (esColaborador) params.es_colaborador = true;

        const response = await axios.get(`${API_URL}/api/festivos/combinados`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            },
            params
        });
        return response.data;
    };

    try {
        return await getCachedData(cacheKey, fetchFn, FESTIVOS_CACHE_TTL);
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchFestivosByCalendario = async (calendarioId, anio = null) => {
    const cacheKey = `${CACHE_KEYS.FESTIVOS}_calendario_${calendarioId}_${anio || 'all'}`;

    const fetchFn = async () => {
        const params = {};
        if (anio) params.anio = anio;

        const response = await axios.get(`${API_URL}/api/festivos/calendario/${calendarioId}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            },
            params
        });
        return response.data;
    };

    try {
        return await getCachedData(cacheKey, fetchFn, FESTIVOS_CACHE_TTL);
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchFestivosByCalendarioColab = async (calendarioId, anio = null) => {
    const cacheKey = `${CACHE_KEYS.FESTIVOS}_calendario_colab_${calendarioId}_${anio || 'all'}`;

    const fetchFn = async () => {
        const params = {};
        if (anio) params.anio = anio;

        const response = await axios.get(`${API_URL}/api/festivos/calendario-colab/${calendarioId}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            },
            params
        });
        return response.data;
    };

    try {
        return await getCachedData(cacheKey, fetchFn, FESTIVOS_CACHE_TTL);
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const fetchFestivo = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/festivos/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const crearFestivo = async (data) => {
    try {
        const response = await axios.post(`${API_URL}/api/festivos`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        invalidateCacheByPrefix(CACHE_KEYS.FESTIVOS);
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const actualizarFestivo = async (id, data) => {
    try {
        const response = await axios.put(`${API_URL}/api/festivos/${id}`, data, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        invalidateCacheByPrefix(CACHE_KEYS.FESTIVOS);
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};

export const eliminarFestivo = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/api/festivos/${id}`, {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("token")}`
            }
        });
        invalidateCacheByPrefix(CACHE_KEYS.FESTIVOS);
        return response.data;
    } catch (error) {
        handleAuthError(error);
        throw error;
    }
};
